import VueI18n from 'vue-i18n'

import {
  loadLanguageAsync,
  getLanguages,
  setLanguage,
  getLanguageByCode,
  TranslateEventBus,
  i18n
} from './src/translate'

import {
  goBackToLogin,
  redirect
} from './src/routing'

import { isString, isArray } from './src/validate'

import { camelToSnakeCase } from './src/utils'

import Auth from './src/auth'
import Cookie from './src/cookie'
import DomainName from './src/domain'
import request from './src/request'

/**
 * @module client/index-no-deps
 * @category client
 */

/**
 * Vue plugin for CoderZ utilities (no dependencies version).
 * 
 * This plugin provides internationalization and utility functions
 * to Vue applications without external dependencies.
 *
 * @namespace CoderzPlugin
 * @memberof module:client/index-no-deps
 */
const CoderzPlugin = {
  install (Vue, options) {
    Vue.use(VueI18n)
    Vue.prototype.$coderz = {
      getLanguages: () => {
        return getLanguages()
      },
      setLanguage: async (lang) => {
        await setLanguage(lang)
      },
      getLanguageByCode: (lang) => {
        return getLanguageByCode(lang)
      },
      camelToSnakeCase: (s) => camelToSnakeCase(s),
      TranslateEventBus
    }
  }
}

/**
 * Utility functions for general use.
 *
 * @namespace utils
 * @memberof module:client/index-no-deps
 */
const utils = {
  camelToSnakeCase
}

/**
 * Translation and internationalization utilities.
 *
 * @namespace translationUtils
 * @memberof module:client/index-no-deps
 */
const translationUtils = {
  i18n,
  loadLanguageAsync,
  setLanguage,
  getLanguageByCode,
  getLanguages
}

/**
 * Routing utilities for navigation.
 *
 * @namespace routingUtils
 * @memberof module:client/index-no-deps
 */
const routingUtils = {
  goBackToLogin,
  redirect
}

/**
 * Validation utilities for data validation.
 *
 * @namespace validationUtils
 * @memberof module:client/index-no-deps
 */
const validationUtils = {
  isString,
  isArray
}

export {
  translationUtils,
  routingUtils,
  validationUtils,
  request,
  utils,
  Auth,
  Cookie,
  DomainName
}

export default CoderzPlugin
